export default __webpack_public_path__ + "static/media/6.a1412b21.jpg";